import { async, html } from '@rxdi/lit-html';
import { BehaviorSubject, iif, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { BaseComponent } from '../base.component';

export class BaseComponentWithLoading extends BaseComponent {
  loading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  loadingTemplate = this.loading.pipe(
    mergeMap((v) => iif(() => v, of(html` <loading-screen-component></loading-screen-component> `), of('')))
  );

  showLoading() {
    this.loading.next(true);
  }

  hideLoading() {
    this.loading.next(false);
  }

  getLoadingTemplate() {
    return async(this.loadingTemplate);
  }

  isLoading() {
    return this.loading.getValue();
  }
}
